<template>
  <v-card>
    <v-card-title class="grey lighten-5 headline">
      Upload de Documentos Pendentes
    </v-card-title>
    <v-row class="pa-4" justify="space-between">
      <v-col cols="4">
        <v-form>
          <v-container>
            <div v-if="entidade.grupoID !== 0">
              <v-row
                v-for="prop in entidade.entidadePropriedades"
                :key="prop.grupoPropriedadeID"
              >
                <v-col>
                  <v-text-field
                    :label="prop.nome"
                    v-model="prop.valor"
                    disabled
                  ></v-text-field>
                </v-col>
              </v-row>
            </div>
          </v-container>
        </v-form>
      </v-col>

      <v-divider vertical></v-divider>

      <v-col>
        <form @submit.stop.prevent="sincronizar">
          <v-row>
            <v-col><h5>Documentos Vinculados</h5></v-col>
            <v-col
              ><v-btn
                type="submit"
                color="success"
                small
                dark
                style="float: right"
                ><v-icon small>fas fa-cloud-upload-alt</v-icon
                ><span class="ml-2">Sincronizar</span></v-btn
              ></v-col
            >
          </v-row>

          <v-divider></v-divider>

          <v-simple-table>
            <template v-slot:default>
              <tbody>
                <tr
                  v-for="(doc, indexDoc) in documentos"
                  :key="doc.id + '-' + doc.periodo"
                >
                  <td align="left" style="width: 20%">{{ doc.nome }}</td>
                  <td align="left" style="width: 15%">{{ doc.periodo }}</td>
                  <td align="left" style="width: 20%">
                    <v-chip color="warning" v-if="doc.status === 3">
                      Aguardando Validação
                    </v-chip>
                    <v-chip color="warning" v-if="doc.status === 2">
                      Aguardando Arquivos
                    </v-chip>
                    <v-chip color="success" v-if="doc.status === 1">
                      Aprovado
                    </v-chip>
                    <v-chip color="error" v-if="doc.status === 0">
                      Reprovado
                    </v-chip>
                  </td>
                  <td>
                    <v-btn
                      color="primary"
                      fab
                      x-small
                      dark
                      @click="novoArquivo(doc.id)"
                      v-if="
                        doc.status === 2 || doc.status === 3 || doc.status === 0
                      "
                      ><v-icon>mdi-plus</v-icon></v-btn
                    >
                  </td>
                  <td class="pt-2 pb-2">
                    <v-text-field
                      v-if="doc.tipoDocumentoID === 4"
                      label="Data de validade"
                      v-model="doc.validadeString"
                      type="date"
                      required
                      clearable
                    ></v-text-field>
                    <div
                      v-for="(arq, indexArq) in doc.arquivos"
                      :key="arq.nome"
                    >
                      <input
                        type="file"
                        accept="image/png, image/jpeg, image/jpg, image/bmp, image/webp"
                        class="mb-2"
                        required
                        @change="setFiles"
                        :data-indexarq="indexArq"
                        :data-indexdoc="indexDoc"
                        v-if="
                          doc.status === 2 ||
                          doc.status === 3 ||
                          doc.status === 0
                        "
                      />
                    </div>
                  </td>
                  <td>
                    <v-btn
                      color="error"
                      icon
                      @click="excluirArquivo(indexDoc, indexArq)"
                      v-if="
                        doc.status === 2 || doc.status === 3 || doc.status === 0
                      "
                      ><v-icon small>fas fa-trash</v-icon></v-btn
                    >
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </form>
      </v-col>
    </v-row>
    <TelaLoading :overlay="saving"></TelaLoading>
  </v-card>
</template>

<script>
import ApiService from "@/common/services/http/api.service";
import Swal from "sweetalert2";
import SweetAlert from "@/common/services/sweetalert.service";
import TelaLoading from "@/views/components/TelaLoading.vue";

export default {
  name: "upload",
  data() {
    return {
      saving: false,
      empresas: [],
      grupos: [],
      documentos: [],
      entidade: {
        id: 0,
        empresaID: 0,
        grupoID: 0,
        entidadePropriedades: [],
      },
    };
  },
  components: {
    TelaLoading,
  },
  methods: {
    listaEmpresas() {
      return new Promise((resolve) => {
        ApiService.get("empresa/getbyclienteid/" + this.cliente.id).then(
          ({ data }) => {
            if (data.success) {
              resolve(data);
              this.empresas = data.data;
            } else SweetAlert.sweetAlertError(data.errors);
          }
        );
      });
    },

    listaGrupos() {
      return new Promise((resolve) => {
        ApiService.get("grupo/getbyclienteid/" + this.cliente.id).then(
          ({ data }) => {
            resolve(data);
            if (data.success) this.grupos = data.data;
            else SweetAlert.sweetAlertError(data.errors);
          }
        );
      });
    },

    listaDocumentos() {
      let self = this;
      return new Promise((resolve) => {
        ApiService.get("registro/getPendencias/" + this.cliente.id).then(
          ({ data }) => {
            resolve(data);

            if (data.success)
              data.data
                .filter((x) => {
                  return x.entidadeID === self.entidade.id;
                })
                .forEach((x) => {
                  this.documentos.push({
                    id: x.documentoID,
                    nome: x.documento,
                    periodo: x.periodo,
                    status: x.statusPendencia,
                    tipoDocumentoID: x.tipoDocumentoID,
                    validadeString: x.validadeString,
                    arquivos: [{ nome: "", arquivo: {} }],
                  });
                });
            else SweetAlert.sweetAlertError(data.errors);
          }
        );
      });
    },

    listaGrupoPropriedades() {
      return new Promise((resolve) => {
        ApiService.get(
          "grupopropriedade/getbygrupoid/" + this.entidade.grupoID
        ).then(({ data }) => {
          if (data.success) {
            resolve(data);
            this.entidade.entidadePropriedades = [];

            data.data.forEach((x) => {
              this.entidade.entidadePropriedades.push({
                entidadeID: 0,
                grupoPropriedadeID: x.id,
                nome: x.nome,
                valor: "",
              });
            });
          } else SweetAlert.sweetAlertError(data.errors);
        });
      });
    },

    buscarEntidade(id) {
      return new Promise((resolve) => {
        ApiService.get("entidade/getbyid/" + id).then(({ data }) => {
          if (data.success) {
            resolve(data);
            this.entidade = data.data;
            this.listaDocumentos();
          } else SweetAlert.sweetAlertError(data.errors);
        });
      });
    },

    novoArquivo(documentoID) {
      this.documentos
        .find((x) => x.id === documentoID)
        .arquivos.push({ nome: "", arquivo: {} });
    },

    excluirArquivo(indexDoc, indexArq) {
      this.documentos[indexDoc].arquivos.splice(indexArq, 1);
    },

    setFiles(event) {
      this.documentos[event.target.dataset.indexdoc].arquivos[
        event.target.dataset.indexarq
      ].arquivo = event.target.files;
    },

    async sincronizar() {
      this.saving = true;

      try {
        if (
          this.documentos.some(
            (d) =>
              d.tipoDocumentoID === 4 &&
              (d.validadeString == null || d.validadeString == "")
          )
        ) {
          this.saving = false;
          const resposta = await Swal.fire({
            position: "center",
            title:
              "Possuem documentos com datas de validade que não foram preenchidas",
            icon: "warning",
            showConfirmButton: false,
            timer: 1500,
          });

          if (!resposta.isConfirmed) return;
        }

        for (let i = 0; i < this.documentos.length; i++) {
          const doc = this.documentos[i];

          for (let j = 0; j < doc.arquivos.length; j++) {
            const arq = doc.arquivos[j];

            let formData = new FormData();

            formData.append("arquivo", arq.arquivo[0]);

            const { data: result } = await ApiService.postFormData(
              "arquivo/upload/" +
                this.entidade.id +
                "/" +
                doc.id +
                "/" +
                this.entidade.grupoID +
                "/" +
                this.cliente.id +
                "/" +
                doc.validadeString,
              formData
            );

            if (!result.success) SweetAlert.sweetAlertError(result.errors);
          }
        }
        this.saving = false;
        Swal.fire({
          position: "center",
          icon: "success",
          title: "Arquivos Sincronizados com Sucesso!",
          showConfirmButton: false,
          timer: 1500,
        });
      } catch (e) {
        this.saving = false;
        Swal.fire({
          position: "center",
          icon: "error",
          title: "Falha ao sincronizar arquivos!",
          showConfirmButton: false,
          timer: 1500,
        });
      }
    },
  },
  mounted() {
    this.cliente = JSON.parse(window.localStorage.getItem("cliente"));

    this.listaEmpresas();
    this.listaGrupos();

    if (this.$route.params.entidadeid !== undefined)
      this.buscarEntidade(this.$route.params.entidadeid);
  },
};
</script>
